import { API_DICTIONARY, HTTP_METHODS } from '../../constants'
import Fetcher from '../../services/Fetcher'
import { THospitalUsersFormRequest, THospitalUsersListResponse } from './types'

const fetcher = new Fetcher({})
export const getHospitalUsersList = async () =>
  fetcher.request<unknown, THospitalUsersListResponse>({
    url: `${API_DICTIONARY.ANALYSIS}${API_DICTIONARY.STAKEHOLDER_ASSIGNMENT}`,
    method: HTTP_METHODS.GET
  })
export const setHospitalUsersList = async (data: THospitalUsersFormRequest) =>
  fetcher.request<unknown, THospitalUsersListResponse>({
    url: `${API_DICTIONARY.ANALYSIS}${API_DICTIONARY.STAKEHOLDER_ASSIGNMENT}`,
    method: HTTP_METHODS.POST,
    data,
    successMessage: 'Clinical review has been updated'
  })
